import { useEffect } from "react";

// Closes a popover when clicking outside of any of the given refs or pressing Escape.
const useDismiss = (isOpen, refs, onClose) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handlePointer = (event) => {
      const inside = refs.some((ref) => ref.current && ref.current.contains(event.target));
      if (!inside) onClose();
    };
    const handleKey = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("mousedown", handlePointer);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handlePointer);
      document.removeEventListener("keydown", handleKey);
    };
  }, [isOpen, refs, onClose]);
};

export default useDismiss;
